import * as React from 'react';
import { debounce } from 'lodash';
import {
  AGENT_MODE,
  AGENT_LAN,
  AGENT_DEPLOY_MODE,
  API,
  NiCommonCascader,
  SELECTION_KEY
} from '@config/index';
import {
  UserContext,
  UserContextProps,
  UserProps,
  AgentInfo,
  AgentContextProps,
  AgentContext,
  DeploymentInfo,
  deploymentInfoToLocal,
  DeploymentStatus
} from '@interface/index';
import {
  VersionButton,
  TryItNow,
  FunctionTestingDrawer,
  NiModal,
  NiForm,
  niConfirm,
  AddVersionObserver,
  RemoveVersionObserver
} from '@component/index';
import {
  MenuFoldOutlined,
  CodeOutlined,
  DeploymentUnitOutlined,
  CopyOutlined,
  ImportOutlined
} from '@ant-design/icons';
import { Popover, Divider, message } from 'antd';
import { AgentPermission, AGENT_OPERATION, EditPermission } from '@permission/index';
import { isReadMode, instance, isProviderAgent, getAgentInfo, getUserId } from '@lib/index';
import { localizedString } from '@locale/index';
import * as FileSaver from 'file-saver';
import { AgentCreateModal } from '@page/agent/create';
import { store } from '@reducer/index';

import '@style/component/right-bar/index.less';
import { GetVersionStatus } from '@component/version/version-button';

export interface LangLevelBarPropsInfo {
  location: any;
  match: any;
  user: UserProps;
  agent?: AgentInfo;
  history: any;
}

export interface LangLevelBarStateInfo {
  demoVisible: boolean;
  funcTestingVisible: boolean;
  deploying: boolean;
  deployInfo?: DeploymentInfo;
  action?: 'clone' | 'import';
  cloneDest?: string;
  importDest?: string[];
  importing: boolean;
  cloneModalVisible: boolean;
  demoDisabled: boolean;
}

const defaultState: LangLevelBarStateInfo = {
  demoVisible: false,
  funcTestingVisible: false,
  deploying: false,
  importing: false,
  cloneModalVisible: false,
  demoDisabled: false
};


class LangLevelBar extends React.Component<LangLevelBarPropsInfo, LangLevelBarStateInfo> {
  public state: LangLevelBarStateInfo = { ...defaultState };

  componentDidMount() {
    AddVersionObserver(this);
    this.onInit();
  }

  componentWillUnmount() {
    RemoveVersionObserver(this);
  }

  onVersionChanged() {
    this.onInit();
  }

  onInit = async () => {
    const { agent } = this.props;

    if (agent && agent.deployMode === AGENT_DEPLOY_MODE.FRAMELY) {
      API.version.deployInfo()
        .then((dpInfo: any) => {

          const info = dpInfo && deploymentInfoToLocal(dpInfo);
          this.setState({
            deployInfo: info,
            demoDisabled: (isProviderAgent() &&
              info && info.status !== DeploymentStatus.Success)

          });
        });
    }
  }

  render() {
    const { agent, user, history, location, match } = this.props;
    const {
      demoVisible,
      funcTestingVisible,
      deployInfo,
      deploying,
      action,
      cloneDest,
      importDest,
      importing,
      cloneModalVisible,
      demoDisabled
    } = this.state;

    return <>
      {
        <div className="right-menu">
          {agent &&
            agent.id &&
            !isReadMode() &&
            AgentPermission(AGENT_OPERATION.COMMIT_TEST) &&
            <>
              {/* <Divider /> */}
              <div className="button-area">
                <VersionButton history={this.props.history} agent={agent} />
              </div>
              <Divider />
            </>
          }
          {
            agent &&
            agent.id &&
            // !isReadMode() &&
            ((agent.mode !== AGENT_MODE.LIBRARY &&
              agent.language !== AGENT_LAN.STRUCT) ||
              isProviderAgent()) &&
            EditPermission() &&
            <>
              <div className="button-area">
                <Popover
                  content={localizedString('sidebar_try_it_now')}
                  placement="left"
                >
                  <MenuFoldOutlined
                    disabled={demoDisabled}
                    className={`${demoDisabled ? 'disabled' : ''}`}
                    onClick={() => {

                      if (demoDisabled) {
                        return;
                      }

                      if (isProviderAgent()) {
                        this.setState({ funcTestingVisible: true });
                      } else {
                        this.setState({ demoVisible: true });
                      }
                    }} />
                </Popover>
              </div>
              <Divider />
            </>
          }
          {/* {
            agent &&
            ((agent.isService && !agent.isInterface) ||
              (agent.mode === AGENT_MODE.APPLICATION &&
                agent.language === AGENT_LAN.STRUCT)) &&
            agent.deployMode === AGENT_DEPLOY_MODE.FRAMELY &&
            !isReadMode() &&
            AgentPermission(AGENT_OPERATION.DEPLOY) &&
            <>
              <div className="button-area">
                <Popover
                  title={localizedString('agent_deploy')}
                  content={`Deploy Status: ${deployInfo && deployInfo.status || 'Unknown'}`}
                  placement="left"
                >
                  <DeploymentUnitOutlined spin={deploying} onClick={this.handleDeploy} />
                </Popover>
              </div>
              <Divider />
            </>
          } */}
          {
            agent &&
            !isReadMode() &&
            (agent.mode === AGENT_MODE.APPLICATION ||
              (agent.isService && agent.isInterface)) &&
            agent.language === AGENT_LAN.STRUCT &&
            // agent.deployMode === AGENT_DEPLOY_MODE.PRIVATE &&
            AgentPermission(AGENT_OPERATION.DEPLOY) &&
            <>
              <div className="button-area">
                <Popover
                  content={localizedString('agent_export')}
                  placement="left"
                >
                  <CodeOutlined spin={deploying} onClick={this.handleExport} />
                </Popover>
              </div>
              <Divider />
            </>
          }
          {
            agent &&
            agent.language === AGENT_LAN.STRUCT &&
            <>
              <div className="button-area">
                <Popover
                  content={localizedString('clone_project')}
                  placement="left"
                >
                  <CopyOutlined onClick={() => {
                    this.setState({ action: 'clone', cloneDest: undefined });
                  }} />
                </Popover>
              </div>
              {!isProviderAgent() && agent.mode !== AGENT_MODE.APPLICATION &&
                <div className="button-area" style={{ marginTop: 16 }}>
                  <Popover
                    content={localizedString('import_project')}
                    placement="left"
                  >
                    <ImportOutlined spin={importing} onClick={() => {
                      this.setState({ action: 'import', importDest: undefined });
                    }} />
                  </Popover>
                </div>
              }
              <Divider />
            </>
          }
        </div>
      }
      {
        < TryItNow
          visible={demoVisible}
          onClose={() => {
            this.setState({ demoVisible: false });
          }}
        />
      }
      {funcTestingVisible &&
        <FunctionTestingDrawer
          visible={funcTestingVisible}
          onClose={() => {
            this.setState({ funcTestingVisible: false });
          }}
        />
      }
      {
        action &&
        <NiModal
          title={localizedString(action === 'clone' ? 'clone_project' : 'import_project')}
          open={!!action}
          onOk={this.handleAction}
          onCancel={() => {
            this.setState({ action: undefined });
          }}
          className="project_action_modal"
        >
          <NiForm
            items={[
              action === 'clone'
                ? {
                  key: 'clone',
                  label: localizedString('clone_to'),
                  content: <NiCommonCascader
                    rootpath={[{
                      value: agent && agent.id || '',
                      value_type: 'agent'
                    }]}
                    selectionkey={SELECTION_KEY.CLONE_DESTINATION}
                    value={cloneDest && [cloneDest] || []}
                    onChange={(value: string[]) => {
                      this.setState({ cloneDest: value.length ? value[0] : undefined });
                    }}
                  />
                }
                : {
                  key: 'import',
                  label: <label style={{ marginTop: 4 }}>{localizedString('import_to')}</label>,
                  content: <NiCommonCascader
                    rootpath={[{
                      value: agent && agent.id || '',
                      value_type: 'agent'
                    }]}
                    selectionkey={SELECTION_KEY.IMPORT_DESTINATION}
                    value={importDest || []}
                    onChange={(value: string[]) => {
                      this.setState({ importDest: value.length ? value : undefined });
                    }}
                  />
                }
            ]}
          />
        </NiModal>
      }
      {agent && cloneModalVisible &&
        <AgentCreateModal
          key={agent && agent.id || ''}
          type={agent.mode === AGENT_MODE.APPLICATION
            ? 'chatbot'
            : (agent.isService && !agent.isInterface)
              ? 'backend'
              : 'component'}
          isCloning
          visible={cloneModalVisible}
          history={history}
          location={location}
          match={match}
          cloneToOrgId={cloneDest}
          cloneAgent={getAgentInfo()}
          didCloseClick={() => {
            this.setState({ cloneModalVisible: false, action: undefined });
          }}
        />
      }
    </>;
  }


  b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  handleExport = async () => {
    this.setState({ deploying: true });

    try {
      const res: any = await API.agent.export();
      const blob = this.b64toBlob(res.data, 'application/zip');
      FileSaver.saveAs(blob, res.filename);
    } catch (e: any) {
      niConfirm({
        width: '60%',
        title: localizedString('common_error_info'),
        content: <pre style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all'
        }}>{e.message}</pre>
      });
    } finally {
      this.setState({ deploying: false });
    }
  }

  handleDeploy = async () => {
    this.setState({ deploying: true });
    try {
      await API.version.deploy();
      this.onInit();
      instance.emit('redeployed');
    } catch (e: any) {

      niConfirm({
        width: '60%',
        title: localizedString('common_error_info'),
        content: <pre style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all'
        }}>{e.message}</pre>
      });
    } finally {
      this.setState({ deploying: false });
    }
  }

  handleAction = debounce(async () => {
    const { action, cloneDest } = this.state;
    if (action === 'clone') {
      this.setState({ cloneModalVisible: true });
    } else if (action === 'import') {
      this.defaultImport(true);
    }
  }, 500);

  defaultImport = async (check?: boolean) => {

    const { agent } = this.props;
    const { importDest } = this.state;

    this.setState({ action: undefined });

    if (!agent) {
      return;
    }

    if (check) {
      const originKey = {
        agentId: agent.id || '',
        userId: 'master',
        commitNumber: ''
      };

      const hostKey = importDest && importDest.length === 3 && {
        agentId: importDest[importDest.length - 1],
        userId: getUserId(),
        commitNumber: ''
      } || undefined;

      if (!hostKey) {
        return;
      }

      this.setState({ importing: true });
      const res: any = await API.agent.libraryCheck(
        'import',
        originKey,
        undefined,
        hostKey
      ).catch((err: Error) => {
        this.setState({ importing: false });
        message.error(err.message);
        throw err;
      });
      this.setState({ importing: false });
      const msg = res.messages && res.messages.length && res.messages.join('\n');
      if (res.not_allow) {
        message.error(msg || localizedString('common_not_allowed'));
        return;
      }

      if (res.not_encourage) {
        niConfirm({
          title: 'Confirm',
          icon: null,
          content: msg,
          onOk: () => {
            this.defaultImport();
          }
        });
        return;
      }
    }

    this.handleImport();
  }

  handleImport = async () => {

    const { agent } = this.props;
    const { importDest } = this.state;

    if (!agent) {
      return;
    }

    this.setState({ importing: true });

    const originKey = {
      agentId: agent.id || '',
      userId: 'master',
      commitNumber: ''
    };

    const hostKey = importDest && importDest.length === 3 && {
      agentId: importDest[importDest.length - 1],
      userId: getUserId(),
      commitNumber: ''
    } || undefined;

    if (!hostKey) {
      return;
    }

    await API.agent.importLibray(
      originKey, hostKey
    ).catch((err: any) => {
      const errMsg = err.data && err.data.length && err.data[0] || err.message;
      message.error(errMsg);
      this.setState({ importing: false });
      throw new Error(errMsg);
    });

    this.setState({ importing: false });
  }
}

export const RightBar = (props: any) => (
  <UserContext.Consumer>
    {($user: UserContextProps) => (
      <AgentContext.Consumer>
        {($agent: AgentContextProps) => <LangLevelBar
          {...props}
          user={$user.user}
          agent={$agent.agent}
        />}
      </AgentContext.Consumer>
    )}
  </UserContext.Consumer>
);
